import type { GetCourseAssets200ContentItem } from './getCourseAssets200ContentItem';
import type { GetCourseAssets200Pageable } from './getCourseAssets200Pageable';

/**
 * 강의 자료 목록 응답
 */
export type GetCourseAssets200 = {
  content?: GetCourseAssets200ContentItem[];
  /** Spring Data Page 객체 형태의 페이징 정보 */
  pageable?: GetCourseAssets200Pageable;
};
